export const presResult2022Mixin = {
    methods: {
        update: function () {
            document.location.reload();
        }
    },
    created: function () {
        this.$refreshHub.$on("pres-2022", this.update);
    }   
};